import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { TranslateModule } from "@ngx-translate/core";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { JeanologiaNgWidgetsModule } from "@jeanologia/ng-widgets";
import { FormlyModule } from "@ngx-formly/core";
import { FormlyMaterialModule } from "@ngx-formly/material";
import { ngfModule } from "angular-file";
import { provideLottieOptions } from "ngx-lottie";
import player from "lottie-web";

import { MaterialModule } from "../shared/utils/material/material.module";
import { ToolDescriptionComponent } from "./components/modals/tool-description/tool-description.component";
import { CancelSubscriptionComponent } from "./components/modals/cancel-subscription/cancel-subscription.component";
import { AdminCancelSubscriptionComponent } from "./components/modals/admin-cancel-subscription/admin-cancel-subscription.component";
import { AdminCancelLicenseComponent } from "./components/modals/admin-cancel-license/admin-cancel-license.component";
import { AdminDontRenewSubscriptionComponent } from "./components/modals/admin-dont-renew-subscription/admin-dont-renew-subscription.component";
import { AdminShowProductLicensesComponent } from "./components/modals/admin-show-product-licenses/admin-show-product-licenses.component";
import { AdminNewPackComponent } from "./components/modals/admin-new-pack/admin-new-pack.component";
import { AdminNewManualComponent } from "./components/modals/admin-new-manual/admin-new-manual.component";
import { LoadingComponent } from "./components/modals/loading/loading.component";
import { DeleteComponent } from "./components/modals/delete/delete.component";
import { ClientLicenceSelectionComponent } from "./components/modals/client-licence-selection/client-licence-selection.component";
import { ClientPaymentResponseComponent } from "./components/modals/client-payment-response/client-payment-response.component";
import { CookiesPolicyViewComponent } from "./components/views/cookies-policy-view/cookies-policy-view.component";
import { PrivatePolicyViewComponent } from "./components/views/private-policy-view/private-policy-view.component";
import { ModalErrorsComponent } from "./components/modals/modal-errors/modal-errors.component";
import { PackFormComponent } from "./forms/pack-form/pack-form.component";
import { DigitOnlyDirective } from "./directives/digit-only.directive";
import { AdminPacksComponent } from "./components/views/admin-packs/admin-packs.component";
import { UserToolComponent } from "./components/views/user-tool/user-tool.component";
import { MyToolsCardComponent } from "./components/views/my-tools-card/my-tools-card.component";
import { AdminClientProductCardComponent } from "./components/modals/admin-client-product-card/admin-client-product-card.component";
import { AdminClientProductCardTrialComponent } from "./components/modals/admin-client-product-card-trial/admin-client-product-card-trial.component";
import { LoadingViewComponent } from "./components/views/loading-view/loading-view.component";
import { ArrowInputComponent } from "./components/modals/arrow-input/arrow-input.component";
import { DownloadToolComponent } from "./components/modals/download-tool/download-tool.component";
import { CaptchaComponent } from "./components/captcha/captcha.component";
import { SatReminderComponent } from "./components/modals/sat-reminder/sat-reminder.component";
import { AdminNewQuotationComponent } from "./components/modals/admin-new-quotation/admin-new-quotation.component";
import { ClientMachineSelectionComponent } from "./components/modals/client-machine-selection/client-machine-selection.component";

@NgModule({
	declarations: [
		ToolDescriptionComponent,
		CancelSubscriptionComponent,
		AdminCancelLicenseComponent,
		AdminCancelSubscriptionComponent,
		AdminDontRenewSubscriptionComponent,
		AdminShowProductLicensesComponent,
		AdminNewPackComponent,
		LoadingComponent,
		AdminNewManualComponent,
		AdminNewQuotationComponent,
		DeleteComponent,
		ClientLicenceSelectionComponent,
		ClientMachineSelectionComponent,
		ClientPaymentResponseComponent,
		CookiesPolicyViewComponent,
		PrivatePolicyViewComponent,
		ModalErrorsComponent,
		PackFormComponent,
		DigitOnlyDirective,
		AdminPacksComponent,
		AdminClientProductCardComponent,
		AdminClientProductCardTrialComponent,
		UserToolComponent,
		MyToolsCardComponent,
		LoadingViewComponent,
		ArrowInputComponent,
		DownloadToolComponent,
		CaptchaComponent,
		SatReminderComponent,
	],
	exports: [
		TranslateModule,
		ToolDescriptionComponent,
		AdminClientProductCardComponent,
		CancelSubscriptionComponent,
		AdminCancelLicenseComponent,
		AdminCancelSubscriptionComponent,
		AdminDontRenewSubscriptionComponent,
		AdminShowProductLicensesComponent,
		AdminClientProductCardTrialComponent,
		AdminNewPackComponent,
		LoadingComponent,
		AdminNewManualComponent,
		AdminNewQuotationComponent,
		DeleteComponent,
		ClientLicenceSelectionComponent,
		ClientMachineSelectionComponent,
		ClientPaymentResponseComponent,
		CookiesPolicyViewComponent,
		ModalErrorsComponent,
		PackFormComponent,
		DigitOnlyDirective,
		AdminPacksComponent,
		UserToolComponent,
		AdminClientProductCardComponent,
		MyToolsCardComponent,
		LoadingViewComponent,
		ArrowInputComponent,
		CaptchaComponent,
		SatReminderComponent,
	],
	imports: [
		ngfModule,
		CommonModule,
		FormlyModule,
		FormlyMaterialModule,
		FormsModule,
		JeanologiaNgWidgetsModule,
		MaterialModule,
		ReactiveFormsModule,
		RouterModule,
		TranslateModule,
	],
	providers: [
		provideHttpClient(withInterceptorsFromDi()),
		provideLottieOptions({
			player: () => player,
		}),
	],
})
export class SharedModule {}
